import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {ServiceRequest} from '../../../../../Models/ServiceRequest';
import {Subscription} from 'rxjs';
import {ServiceRequestService} from '../../../../../Services/service-request.service';

@Component({
  selector: 'app-reply-step-change-status',
  templateUrl: './reply-step-change-status.component.html',
  styleUrls: ['./reply-step-change-status.component.scss']
})
export class ReplyStepChangeStatusComponent implements OnInit, OnDestroy {

  @Input() Index;
  @Input() isActive;

  public request: ServiceRequest = new ServiceRequest();
  private subscriptions: Subscription[] = [];

  constructor(
    private requestService: ServiceRequestService,
  ) { }

  ngOnInit() {
    this.subscriptions.push(
      this.requestService.serviceRequest.subscribe(serviceRequest => {
        this.request = serviceRequest;
        this.request.reply.replyItems = this.request.reply.replyItems.filter(item => !item.solutionStep.restricted);
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
